import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { Button } from 'react-bootstrap';

export const ButtonAwaiting = ({ onClick, isAwaiting, title, awaitingTitle, icon, isPrimary = true }) => {
    return (
        <Button
            variant={isPrimary ? "primary" : "secondary"}
            size="sm"
            className="ms-auto"
            disabled={isAwaiting}
            onClick={onClick}
        >
            {isAwaiting ? (
                <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    {awaitingTitle}
                </>
            ) : (
                <>
                    {icon && <span className="me-2">{icon}</span>}
                    {title}
                </>
            )}
        </Button>
    );
};

export const ButtonDelete = ({ onClick, isDeleting, deleteConfirmationMessage, deleteConfirmationTitle }) => {
    return (
        <Button
            variant="outline-danger"
            className="ms-auto"
            disabled={isDeleting}
            onClick={(e) => {
                e.stopPropagation();
                confirmAlert({
                    title: deleteConfirmationTitle,
                    message: deleteConfirmationMessage,
                    buttons: [
                        {
                            label: 'Yes',
                            onClick: onClick
                        },
                        {
                            label: 'No',
                            onClick: () => { }
                        },
                    ]
                });
            }
            }
        >
            <span>
                {isDeleting ? (
                    <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Deleting...
                    </>
                ) : (
                    <>
                        <span style={{ fontSize: 22 }}>
                            <FontAwesomeIcon icon={faTrash} />
                        </span>
                    </>
                )}
            </span>
        </Button>
    );
};

export const ButtonIcon = ({ onClick, icon, isPrimary = true }) => {
    return (
        <Button className="ms-auto"
            onClick={onClick}
        >
            <span>
              <div style={{fontSize: 22,}}>
                <span>{icon}</span>
              </div>
            </span>
        </Button>
    );
};

export const ButtonMailto = ({ 
    emailAddresses, 
    emailAddressesCallback=() => {}, 
    title, 
    subject, 
    body,
    bodyCallback=() => {},
    confirmCallback,
    sent=false,
}) => {
    
    return (
        <Button className="ms-auto"
            style={{ opacity: sent ? 0.5 : 1}}
            onClick={async (e) => {
              e.stopPropagation();
              const actuallySend = async() => {
                const resolvedEmailAddresses = emailAddresses ? emailAddresses :  await emailAddressesCallback();
                  const resolvedBody = body ? body : await bodyCallback();
                  const mailTo = `mailto:?bcc=${resolvedEmailAddresses.join(',')}&body=${encodeURIComponent(resolvedBody)}&subject=${encodeURIComponent(subject)}`
                  console.log(mailTo);
                  //const newWindow = window.open(mailTo, '_blank', 'noopener,noreferrer');
                  window.location.href=mailTo;
                  //if (newWindow) newWindow.opener = null;
              }
              if (confirmCallback) {
                confirmCallback((res) => {
                  if (res) {
                    actuallySend();
                  }
                })
              } else {
                actuallySend();
              }
          }}>
            <span>
              <div style={{fontSize: 22,}}>
                <i className="fas fa-envelope action"></i>
              </div>
              {
                title && (
                  <div style={{fontSize: 10}}>
                    {title}
                  </div>
                )
              }
            </span>
        </Button>
        
    );
  };